export default __webpack_public_path__ + "static/media/dislike-o.1a36d619.svg";